import React from 'react';
import './HeadingSection.scss';

export default class HeadingSection extends React.Component {
    static Heading = ({ children }) => (
        <div className="heading-label">{children}</div>
    );
    static HeadingMessage = ({ children }) => (
        <div className="heading-message">{children}</div>
    );
    static RowItems = ({ items, children }) => (
        <div className="items row-items">
            {items.map((item, key) => (
                <div key={key} className="item">
                    {children(item)}
                </div>
            ))}
        </div>
    );
    static BoxItem = ({ items, children }) => (
        <div className="items box">{children}</div>
    );
    static oneToTwoColumn = ({ items, children }) => (
        <div className="items box col1 sm-col2">
            {items.map((item, key) => (
                <div key={key} className="item">
                    {children(item)}
                </div>
            ))}
        </div>
    );
    static TwoToThreeColumn = ({ items, children }) => (
        <div className="items box col2 sm-col3">
            {items.map((item, key) => (
                <div key={key} className="item">
                    {children(item)}
                </div>
            ))}
        </div>
    );
    render() {
        const { sectionType } = this.props;
        const sectionClassName = sectionType
            ? `${sectionType} heading-section`
            : 'heading-section';
        return (
            <div className={sectionClassName}>
                {this.props.children(this.state)}
            </div>
        );
    }
}
